import light from "./light"
import dark from "./dark"

const shadows = {
  light,
  dark,
}

export default shadows
